import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sharedStatus: {
    defaultMessage: 'Shared',
    id: 'qAjITt',
    description: 'Shared Packing Slips Status',
  },
  notCompatible: {
    defaultMessage: 'Not compatible',
    id: 'gerAUU',
    description: 'Shared Packing Slips Not Compatible',
  },
});

export default messages;
